import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/core/services/administration/user.service';

@Component({
  selector: 'app-ai-disclaimer-modal',
  templateUrl: './ai-disclaimer-modal.component.html',
  styleUrls: ['./ai-disclaimer-modal.component.scss'],
  standalone: false,
})
export class AIDisclaimerModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal, private userService: UserService) {}
  ngOnInit(): void {}

  close(): void {
    this.userService.setConfirmedAiUsageDisclaimer().subscribe(() => {
      this.activeModal.close();
    });
  }
}
